import React, { useEffect } from 'react'
import LayoutActions from '../redux/actions/LayoutActions'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import UserRoute from '../routers/UserRoute'
import { connect } from 'react-redux'
import { Box } from '@mui/system'
import { layoutPageComponents as components } from './components/layoutPageComponents'

const stripBase = (path) => {
    const base = window.__ADMIN_STOCK_BASENAME__ || '';
    if (!base) return path;
    if (path === base || path === `${base}/`) return '/';
    if (path.startsWith(`${base}/`)) return path.slice(base.length) || '/';
    return path;
};

function StockListsLayout({
    setPathCheck,
    permission,
    reformat
}) {
    const access = reformat(permission.subPage)
        .sort((a, b) => {
            // Check if either 'order' is null
            if (a.order === null && b.order === null) {
                return 0; // Keep the order unchanged if both are null
            } else if (a.order === null) {
                return 1; // Place 'a' (null) after 'b' (non-null)
            } else if (b.order === null) {
                return -1; // Place 'b' (null) after 'a' (non-null)
            }
            // Sort non-null 'order' values normally
            return a.order - b.order;
        });
    
    useEffect(() => {
        // For microfrontend, sync with parent route changes via window.location.pathname
        const checkPathname = () => {
            const strippedPathname = stripBase(window.location.pathname);

            if (strippedPathname === permission.route || strippedPathname.startsWith(permission.route + '/')) {
                setPathCheck(permission.route);
            }
        };
        
        // Check immediately
        checkPathname();
        
        // Set up interval to poll for pathname changes (needed for microfrontend parent route changes)
        const interval = setInterval(checkPathname, 50);
        
        // Also listen to popstate events
        window.addEventListener('popstate', checkPathname);
        
        // Listen to pushstate/replacestate (for parent router changes)
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        
        window.history.pushState = function (...args) {
            originalPushState.apply(window.history, args);
            setTimeout(checkPathname, 0);
        };
        
        window.history.replaceState = function (...args) {
            originalReplaceState.apply(window.history, args);
            setTimeout(checkPathname, 0);
        };
        
        return () => {
            clearInterval(interval);
            window.removeEventListener('popstate', checkPathname);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [permission.route, setPathCheck])

    return (
        <div>
            <Box>
                <Switch>
                    <Route exact path={permission.route} render={() => <Redirect to={access[0]?.route}
                    />} />
                    {access.map((permission2, i) =>
                        <UserRoute key={i} exact path={permission2.route} component={components[permission2.key]} permission={permission2} />
                    )}
                    <Redirect from="*" to="/not-found" />
                </Switch>
            </Box>
        </div>
    )
}
const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
    setPathCheck: (data) => dispatch(LayoutActions.setPathCheck(data))
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StockListsLayout))